import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isNonEmptyString } from '@thesavingsgroup/utils/isNonEmptyString';
import { isNonNegativeNumber } from '@thesavingsgroup/utils/isNonNegativeNumber';
import isNil from 'lodash/isNil';

import { YES } from '../../applicantStore/types/YesOrNo';
import { ApplicationSubmittedPayload } from '../types/ApplicationSubmittedPayload';
import { ApplicationSubmittedPayloadParams } from '../types/ApplicationSubmittedPayloadParams';

const toAmount = (value?: number | string | null): number | null => {
  if (isNil(value) || value === '') {
    return null;
  }

  const amount = Number(value);

  return isNonNegativeNumber(amount) ? amount : null;
};

const toPostalCode = (value?: string | null): string | null =>
  isNonEmptyString(value) ? value : null;

export const toApplicationSubmittedPayload = ({
  addCoapplicant,
  coapplicantCurrentIncomeGrossAnnual,
  coapplicantCurrentResidencePostalCode,
  currentIncomeGrossAnnual,
  currentResidencePostalCode,
  vehicle,
}: ApplicationSubmittedPayloadParams): ApplicationSubmittedPayload => {
  const applicationType = vehicle?.application?.applicationType ?? null;
  const hasCoApplicant = addCoapplicant === YES;

  // matches LOS, which is only sent the loan for a refinance
  const payoffAmount =
    applicationType === ApplicationType.REFINANCE
      ? toAmount(vehicle?.payoffAmount)
      : null;

  return {
    applicantPostalCode: toPostalCode(currentResidencePostalCode),
    applicantYearlyIncomeAmount: toAmount(currentIncomeGrossAnnual),
    applicationType,
    coApplicantPostalCode: hasCoApplicant
      ? toPostalCode(coapplicantCurrentResidencePostalCode)
      : null,
    coApplicantYearlyIncomeAmount: hasCoApplicant
      ? toAmount(coapplicantCurrentIncomeGrossAnnual)
      : null,
    financeAmount: payoffAmount || toAmount(vehicle?.purchasePrice),
    hasCoApplicant,
    partnerRecordUniqueIdentifier:
      vehicle?.application?.uniqueIdentifier || null,
    payoffAmount,
  };
};
